<template>
  <div style="height:100%">
    <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
      <div class="title-h4">
        <i class="fal fa-arrow-left" style="cursor:pointer" @click="onClickBackButton"></i> {{title}}
      </div>
      <w-header-search-button @click="showSearchTool = !showSearchTool" size="mini"></w-header-search-button>
    </el-row>
    <el-table-wrapper v-loading="isLoading" :style="fitHeight ? { height: '100%' } : null" :fit-height="fitHeight" ref="interfaceTable" :data="tableData"
    :total="total" :columns="tableColumns" :show-search-tool="showSearchTool" remote pagination :show-custom-header="showCustomHeader" @condition-change="onConditionChange"
    @select="onSelect" @select-all="onSelectAll">
      <template slot-scope="scope" slot="interface-slot">
        <i class="el-icon-search" style="cursor: pinter" />
      </template>
    </el-table-wrapper>
  </div>
</template>

<script>
import { isEmpty, isNil, filter, cloneDeep } from 'lodash';
import logicalGroupApi from '@/api/settings/common/logical-group';
import { columnDefault } from '@/constants/table';
import { getValueAfterCheckEmpty } from '@/utils/string';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);

export default {
  name: 'WInterfaceTable',
  props: {
    height: {
      type: String,
    },
    fitHeight: {
      type: Boolean,
    },
    filterParams: {
      type: Object,
      default: () => {},
    },
    active: {
      type: Boolean,
      default: false,
    },
    deviceData: {
      type: Object,
      default: () => {},
    },
    checkedObjList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    title() {
      let title = '인터페이스 목록';
      if (!isNil(this.deviceData)) {
        title = `${this.deviceData.objName} (${this.deviceData.ipaddress})`;
      }
      return title;
    },
  },
  data() {
    return {
      isLoading: false,
      showSearchTool: false,
      showCustomHeader: true,
      tableData: null,
      originTableData: null,
      total: null,
      columnDefault,
      tableColumns: [
        {
          type: 'selection',
          width: 55,
        },
        {
          prop: 'netinterfaceIfindex',
          // remoteProp: 'ni.netinterface_ifindex',
          label: '인덱스',
          searchable: true,
          sortable: true,
          width: 100,
          formatter: defaultFormatter,
        },
        {
          prop: 'objName',
          // remoteProp: 'o.obj_name',
          label: '인터페이스 명',
          searchable: true,
          sortable: true,
          formatter: defaultFormatter,
        },
        {
          prop: 'netinterfaceName',
          // remoteProp: 'ni.netinterface_name',
          label: '물리 인터페이스 명',
          searchable: true,
          sortable: true,
          formatter: defaultFormatter,
        },
      ],
    };
  },
  watch: {
    active: {
      handler(value) {
        if (value) {
          this.loadData();
        } else {
          this.$refs.interfaceTable.clearFilter();
          this.showSearchTool = false;
        }
      },
    },
  },
  methods: {
    loadData() {
      if (!this.active) {
        return;
      }
      this.isLoading = true;
      const filterParams = cloneDeep(this.filterParams);
      filterParams.params.managetypeKey = 'NI';
      const tableParams = {
        objId: this.deviceData.objId,
        ...filterParams.params,
        ...this.$refs.interfaceTable.getParameter(),
      };
      logicalGroupApi
        .getPhysicalObjList(tableParams)
        .then((response) => {
          const result = response.data;
          if (!isEmpty(result) && result.success === true && !isEmpty(result.data)) {
            result.data.forEach((row) => {
              const checkedObj = this.checkedObjList.find((obj) => (obj.objId === row.objId));
              row.checked = !isNil(checkedObj) ? 1 : 0;
            });
            this.tableData = result.data;
            this.total = result.total;
            const originalData = filter(result.data, (item) => item.checked);
            this.originTableData = originalData;
            this.$nextTick(() => {
              this.toggleRowSelection(originalData);
            });
          } else {
            this.tableData = [];
            this.total = 0;
          }
        })
        .catch(() => {
          // this.managegrpObjData.loading = false;
          this.tableData = [];
          this.total = 0;
        }).finally(() => {
          this.isLoading = false;
        });
    },
    onConditionChange() {
      this.loadData();
    },
    onClickBackButton() {
      this.$emit('on-click-back-button');
    },
    onSelect(selection, row) {
      const checkedObj = this.checkedObjList.find((obj) => (obj.objId === row.objId));
      if (!isNil(checkedObj)) {
        this.checkedObjList.splice(this.checkedObjList.indexOf(checkedObj), 1);
      } else {
        this.checkedObjList.push(row);
      }
    },
    onSelectAll(selection) {
      const tableData = this.tableData;
      tableData.forEach((row) => {
        const checkedObj = this.checkedObjList.find((obj) => (obj.objId === row.objId));
        if (selection.length > 0) {
          if (isNil(checkedObj)) {
            this.checkedObjList.push(row);
          }
        } else if (selection <= 0) {
          if (!isNil(checkedObj)) {
            this.checkedObjList.splice(this.checkedObjList.indexOf(checkedObj), 1);
          }
        }
      });
    },
    toggleRowSelection(rows) {
      rows.forEach((row) => {
        this.$refs.interfaceTable.getTable().toggleRowSelection(row);
      });
    },
    clearSelection() {
      this.$refs.interfaceTable.getTable().clearSelection();
    },
    setCheckObjTable() {
      if (!isNil(this.tableData)) {
        this.tableData.forEach((row) => {
          const checkedObj = this.checkedObjList.find((obj) => (obj.objId === row.objId));
          row.checked = !isNil(checkedObj) ? 1 : 0;
        });
        const originalData = filter(this.tableData, (item) => item.checked);
        this.$nextTick(() => {
          this.clearSelection();
          this.toggleRowSelection(originalData);
        });
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/table/PhysicalObjTable/components/InterfaceTable.vue